import React from "react";

export default function RecommendedPositionCard({ card }) {
  if (!card) return null;
  return (
    <div
      className="relative mt-8 rounded-[10px] border border-[#D6D6D6] overflow-hidden shadow-sm"
      style={{
        width: 367,
        height: 487.16,
        minWidth: 367,
        minHeight: 487.16,
        background: "linear-gradient(140deg, #fff 60%, #ECF8F7 100%)"
      }}
    >
      {/* Header bar */}
      <div
        className="w-full flex justify-center"
        style={{
          height: 38,
          background: "#186D6C",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
        }}
      >
        <div
          className="uppercase font-medium text-[13px] text-white mt-2"
          style={{
            fontFamily: "Gotham, sans-serif",
            fontWeight: 350,
            letterSpacing: 0,
          }}
        >
          {card.header}
        </div>
      </div>
      <div
        className="absolute z-10 bg-white flex flex-col"
        style={{
          width: 367,
          height: 431,
          borderRadius: 10,
          top: 30,
          left: 0,
          padding: 20,
          boxSizing: "border-box",
          background: "linear-gradient(140deg, #fff 60%, #ECF8F7 100%)"
        }}
      >
        <div className="flex flex-col items-start mb-3">
          <img
            src={card.img}
            alt={card.alt || "Level Icon"}
            className="w-[80px] h-[80px] rounded-full bg-[#0E918F] object-contain mb-3"
            style={{ minWidth: 80, minHeight: 80 }}
            draggable={false}
          />
          <div className="text-[#13AAA4] text-left text-[24px] leading-[160%] mb-1"
            style={{
              fontFamily: "Gotham, sans-serif",
              fontWeight: 350,
              letterSpacing: "0"
            }}
          >
            {card.name}
          </div>
          <div className="text-[#222] text-left text-[16px] leading-[160%] mb-2 font-normal"
            style={{
              fontFamily: "Gotham, sans-serif",
              fontWeight: 325
            }}
          >
            {card.tagline}
          </div>
        </div>
        <div className="text-left font-medium text-[18px] leading-[160%] text-[#141414] mb-2 mt-3"
          style={{
            fontFamily: "Gotham, sans-serif",
            fontWeight: 350,
            letterSpacing: 0
          }}
        >
          Key Positioning Tactics
        </div>
        <ul className="mb-0 pl-0 flex flex-col gap-1">
          {card.bullets.map((txt, i) => (
            <li
              key={i}
              className="flex flex-row items-center text-[14px] leading-[160%] text-[#222] font-normal mb-1"
              style={{
                fontFamily: "Gotham, sans-serif",
                fontWeight: 325
              }}>
              <span className="mr-3 flex items-center justify-center">
                <span className="inline-flex items-center justify-center rounded-full bg-black" style={{ width: 16, height: 16 }}>
                  <svg width={10} height={10} viewBox="0 0 12 12" fill="none" className="block">
                    <circle cx={6} cy={6} r={6} fill="#000" />
                    <path d="M4 6.4l1.52 1.43c.09.08.23.07.31-.02L8.5 5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
              </span>
              {txt}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
